var _rect, _polygon, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokerage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    points: "24.002 96 232.002 96 128.002 32 24.002 96"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.002,
    x2: 56.002,
    y1: 96,
    y2: 176,
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 104.002,
    x2: 104.002,
    y1: 96,
    y2: 176,
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 152.002,
    x2: 152.002,
    y1: 96,
    y2: 176,
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200.002,
    x2: 200.002,
    y1: 96,
    y2: 176,
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 32.002,
    x2: 224.002,
    y1: 176,
    y2: 176,
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16.002,
    x2: 240.002,
    y1: 208,
    y2: 208,
    fill: "none",
    stroke: "#470985",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerage);
export default __webpack_public_path__ + "static/media/brokerage.c61fc0af417246bb710777ec969d40d3.svg";
export { ForwardRef as ReactComponent };